export enum TypeOfEvent {
  CODERUN = 'CR',
  LANGAUGECHANGE = 'LC',
  CODEADDED = 'CA',
  INTERVIEWENDED = 'IE',
  INTERVIEWSTARTED = 'IS',
  INTERVIEWRESTARTED = 'IRS',
  CODEPASTED = 'CP',
  TABSWITCHED = 'TS', // This is the Event for code editor tab switch proctor event
  TABCHANGE = 'TC', // This is the actual Tabs
  TESTSRESULT = 'TR',
  QUESTIONADDED = 'QA',
  CODING_CONTAINER_SHOWN = 'CCS',
  CODING_CONTAINER_HIDDEN = 'CCH',
  JOINED = 'JN',
  MICSTATECHANGED = 'MC', // Mic State Changed
  MIC_MUTED = 'MMT',
  MIC_UNMUTED = 'MUT',
  VIDEOSTATECHANGED = 'VC', // Video State Changed
  WHITEBOARDSTATECHANGED = 'WC', // Whiteboard State Changed
  CONTENTSHARESTATECHANGED = 'CS', // Screen Share State Change
  INT_AUDIO_STARTED = 'IAS', // interviewer audio started
  INT_AUDIO_ENDED = 'IAE', // interviewer audio ended
  CAN_AUDIO_STARTED = 'CAS',
  CAN_AUDIO_ENDED = 'CAE',
  FULL_SCREEN_ESCAPE = 'FSE', // This is the Event for code editor tab switch proctor event
  PROJECT_LAUNCHED = 'PL',
  PROJECT_SWITCHED = 'PSW',
  PROJECT_RELOADED = 'PRE',
  PROJECT_FAILED = 'PF',
  PROJECT_TAB_CLOSED = 'PTC',
  // AI Assist — playback markers (additive). Only for state that would otherwise
  // be lost because its source node is overwritten (see docs PLAYBACK-DATA-PLAN).
  AI_ACCESS_REQUESTED = 'AAR',
  AI_ACCESS_APPROVED = 'AAA',
  AI_ACCESS_DENIED = 'AAD',
  AI_ACCESS_REVOKED = 'AARV',
  AI_EDIT_MODE_CHANGED = 'AMDC',
}

export enum InterviewerPresent {
  NOTPRESENT = 0,
  PRESENT = 1,
}

export interface EventType {
  name: string;
  userType: string;
  type: TypeOfEvent;
  major: boolean;
  ip: InterviewerPresent;
  output: { stdout: string; stderr: string; time: string };
  language: string;
  code: string;
  pos: { cl: number; ln: number };
  timestamp: number;
}

export interface NewEventType {
  orderId: number;
  name: string;
  userType: string;
  type: TypeOfEvent;
  major: boolean;
  ip: InterviewerPresent;
  output: { stdout: string; stderr: string; time: string };
  language: string;
  code: string;
  pos: { cl: number; ln: number };
  timestamp: number;
}

export interface EventV2Type {
  name: string;
  userType: string;
  type: TypeOfEvent;
  ip: InterviewerPresent;
  output: { stdout: string; stderr: string; time: string };
  language: string;
  code: string;
  timestamp: number;
  linesPasted?: number;
}

export interface EventV4Type {
  name: string;
  activeTab: string;
  userType: string;
  type: TypeOfEvent;
  output?: { stdout: string; stderr: string; time: string };
  tests?: any[];
  language: string;
  code: string;
  timestamp: number;
  question?: any;
  linesPasted?: number;
  isMicActive?: boolean;
  isVideoActive?: boolean;
  isWhiteBoardOpened?: boolean;
  isScreenShareActive?: boolean;
  stackName?: string;
  previousStackName?: string;
  // AI Assist markers (optional → existing events unaffected).
  targetUserId?: string;
  targetUserName?: string;
  by?: string;
  mode?: string;
}
